<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.66667 15.8333L6.53333 6.43333L5.33333 6.9V9.16667H4V6.03333L7.36667 4.6C7.52222 4.53333 7.68611 4.49444 7.85833 4.48333C8.03056 4.47222 8.19444 4.49444 8.35 4.55C8.50556 4.60556 8.65278 4.68333 8.79167 4.78333C8.93056 4.88333 9.04444 5.01111 9.13333 5.16667L9.8 6.23333C10.0889 6.7 10.4806 7.08333 10.975 7.38333C11.4694 7.68333 12.0333 7.83333 12.6667 7.83333V9.16667C11.8889 9.16667 11.1944 9.00556 10.5833 8.68333C9.97222 8.36111 9.45 7.95 9.01667 7.45L8.6 9.5L10 10.8333V15.8333H8.66667V11.5L7.26667 10.4333L6.06667 15.8333H4.66667ZM9 4.16667C8.63333 4.16667 8.31944 4.03611 8.05833 3.775C7.79722 3.51389 7.66667 3.2 7.66667 2.83333C7.66667 2.46667 7.79722 2.15278 8.05833 1.89167C8.31944 1.63056 8.63333 1.5 9 1.5C9.36667 1.5 9.68056 1.63056 9.94167 1.89167C10.2028 2.15278 10.3333 2.46667 10.3333 2.83333C10.3333 3.2 10.2028 3.51389 9.94167 3.775C9.68056 4.03611 9.36667 4.16667 9 4.16667Z"
      fill="#383838"
    />
  </svg>
</template>
